<div class="challenge-result-container" *ngIf="displayModal && (gameStatus == 4 || gameStatus == 3) && challenge?.ChallengeRewarded != true">
  <div class="challenge-result" [ngClass]="{
    'defeat-challenge-result': gameStatus == 4
    }">
    <div class="close-icon">
      <button type="button" (click)="closeBattleBoatResult()" class=""></button>
    </div>
    <div class="header">
      <h1 class="metric-title" *ngIf="!!textByStatus[gameStatus]?.winMessage">{{ challenge?.Metrics }}</h1>
      <div class="header-defeat-battle" *ngIf="gameStatus == 4" >
      </div>
    </div>
    <h2 class="tittle" [ngClass]="{
      'defeat-challenge-tittle': gameStatus == 4
      }" cvLocalizedText langSection="Challenges" langKey="{{textByStatus[gameStatus]?.title}}">{{textByStatus[gameStatus]?.title || ''}}</h2>
    <div class="win-message" *ngIf="!!textByStatus[gameStatus]?.winMessage">
      <h2 cvLocalizedText langSection="Challenges" langKey="{{textByStatus[gameStatus]?.winMessage}}">{{textByStatus[gameStatus]?.winMessage}}</h2>
      <div class="coins">
        <svg class="header-coin">
          <use href="../../../App_Themes/clearview-default/icons/utility/coins.svg#coins">
          </use>
        </svg>
        <h3>{{ challenge?.Wager }}</h3>
      </div>
    </div>
    <div class="text-description">
      <p class="description" [ngClass]="{
        'defeat-description': gameStatus == 4
        }" cvLocalizedText langSection="Challenges" langKey="{{textByStatus[gameStatus]?.description}}">{{textByStatus[gameStatus]?.description || ''}}</p>
    </div>
    <div class="btn-close">
      <button cvLocalizedText langSection="Challenges" langKey="close" type="button" (click)="closeBattleBoatResult()">
        Close
      </button>
    </div>
  </div>
</div>